export default __webpack_public_path__ + "static/media/defaultProfile.336221c6.png";